import React, { Fragment } from 'react';
import { Bell, Search, Menu, HelpCircle } from 'lucide-react';
interface HeaderProps {
  title: string;
  breadcrumbs?: string[];
  onMenuClick: () => void;
  sidebarOpen: boolean;
}
export function Header({
  title,
  breadcrumbs = [],
  onMenuClick,
  sidebarOpen
}: HeaderProps) {
  const handleMenuClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    console.log('Menu button clicked in Header');
    onMenuClick();
  };
  return <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-4 lg:px-6 sticky top-0 z-30 shadow-sm flex-shrink-0" data-id="element-26">
      {/* Left Section */}
      <div className="flex items-center gap-3 lg:gap-4 flex-1 min-w-0" data-id="element-27">
        {/* Menu Toggle Button - Always Visible */}
        <button type="button" onClick={handleMenuClick} className="p-2 hover:bg-gray-100 rounded-lg transition-colors flex-shrink-0 active:bg-gray-200" aria-label={sidebarOpen ? 'Tutup menu' : 'Buka menu'} data-id="element-28">
          <Menu size={22} className="text-gray-600" data-id="element-29" />
        </button>

        {/* Title & Breadcrumbs */}
        <div className="min-w-0 flex-1" data-id="element-30">
          <h1 className="text-lg lg:text-xl font-bold text-gray-900 truncate" data-id="element-31">
            {title}
          </h1>
          {breadcrumbs.length > 0 && <div className="hidden sm:flex items-center gap-2 text-xs text-gray-500 mt-0.5" data-id="element-32">
              {breadcrumbs.map((crumb, index) => <Fragment key={index} data-id="element-33">
                  <span className="truncate" data-id="element-34">{crumb}</span>
                  {index < breadcrumbs.length - 1 && <span className="text-gray-400" data-id="element-35">/</span>}
                </Fragment>)}
            </div>}
        </div>
      </div>

      {/* Right Section */}
      <div className="flex items-center gap-2 lg:gap-3 ml-2 lg:ml-4" data-id="element-36">
        {/* Search Bar - Desktop Only */}
        <div className="hidden md:flex relative" data-id="element-37">
          <input type="text" placeholder="Cari data..." className="w-48 lg:w-64 pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-bulog-blue focus:border-transparent text-sm transition-all" data-id="element-38" />
          <Search className="absolute left-3 top-2.5 text-gray-400" size={18} data-id="element-39" />
        </div>

        {/* Divider */}
        <div className="hidden sm:block h-6 w-px bg-gray-300" data-id="element-40"></div>

        {/* Notification Button */}
        <button type="button" className="p-2 text-gray-500 hover:bg-gray-100 rounded-full relative transition-colors" aria-label="Notifikasi" data-id="element-41">
          <Bell size={20} data-id="element-42" />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full border-2 border-white" data-id="element-43"></span>
        </button>

        {/* Help Button */}
        <button type="button" className="hidden sm:flex p-2 text-gray-500 hover:bg-gray-100 rounded-full transition-colors" aria-label="Bantuan" data-id="element-44">
          <HelpCircle size={20} data-id="element-45" />
        </button>
      </div>
    </header>;
}